module.exports = __webpack_public_path__ + "assets/average-score.817f9acd.svg";